export const isPortableScreen = () => {
  return window.innerWidth < 1130;
};

export const isPalmScreen = () => {
  return window.innerWidth < 800;
};
